import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import * as echarts from 'echarts/types/dist/echarts';
import * as Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import { LndDashboardDetailComponent } from '../lnd-dashboard-detail/lnd-dashboard-detail.component';

// Exporting(Highcharts); // Initialize exporting module

@Component({
  selector: 'app-lnd-dashboard',
  templateUrl: './lnd-dashboard.component.html',
  styleUrls: ['./lnd-dashboard.component.scss'],
})
export class LndDashboardComponent  implements OnInit {

  months = [
    { name: 'January', value: '01' },
    { name: 'February', value: '02' },
    { name: 'March', value: '03' },
    { name: 'April', value: '04' },
    { name: 'May', value: '05' },
    { name: 'June', value: '06' },
    { name: 'July', value: '07' },
    { name: 'August', value: '08' },
    { name: 'September', value: '09' },
    { name: 'October', value: '10' },
    { name: 'November', value: '11' },
    { name: 'December', value: '12' }
  ];

  years = Array.from({ length: 10 }, (_, i) => {
    const startYear = new Date().getFullYear() - i;
    const endYear = startYear + 1;
    return { year: `${startYear} - ${endYear}` };
  });
  isUserEmployee: boolean = false;
  selectedMonth: string = this.months[0].value;  // Default: January
  selectedYear: string = this.years[0].year;     // Default: Current Fiscal Year
  graphType: string = 'bar';  // Default chart type
  fiscalYears: string[] = ['2023-24', '2024-25'];
  //selectedYear: string = '2024-25';
  programs: string[] = ['Programme A', 'Programme B'];
  selectedProgramme: string = 'Programme A';

  chartOptions: any;
  taskColumnHeaderInfoForFinanse: any = []
  allTeamMemberReimbursementApprove: any = []
 
  buttonColorName: any;
  
  constructor(public dialog: MatDialog,private cdRef: ChangeDetectorRef) { }


  ngOnInit() {
    
    this.loadGraph();
    
  }

  switchGraphType(type: string) {
    this.graphType = type;
    this.loadGraph();
  }

 onClickCard(event: any) {
 
    
 
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '70%';
    dialogConfig.data = {
      btn2: 'OK',
      moduleName: event,
      btn2BgColor: this.buttonColorName,
      showSuccessIcon: true,
      showSuccessMessage: false,
      showCloseIcon: false
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(LndDashboardDetailComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((_result) => {
    });

  }



// onClickCard(moduleName: string) {
  
//   const dialogConfig = new MatDialogConfig();
  
//   dialogConfig.height = '70%';
//   dialogConfig.width = '100%';
//   dialogConfig.data = {
//     btn2: 'OK',
//     moduleName: moduleName,  
//     btn2BgColor: this.buttonColorName,
//     showSuccessIcon: true,
//     showSuccessMessage: false,
//     showCloseIcon: false
//   };
//   dialogConfig.panelClass = 'custom-dialog-container';

//   const dialogRef = this.dialog.open(LndDashboardDetailComponent, dialogConfig);
//   dialogRef.afterClosed().subscribe((_result) => {});
// }

  



  downloadGraph() {}

  loadGraph() {
    this.chartOptions = {
      chart: {
        type: 'column', // Change from 'bar' to 'column' to make bars vertical
        height: 400,
      },
      title: { text: '' }, // No title needed
      xAxis: {
        categories: ['Program A', 'Program B', 'Program C', 'Program D', 'Program E', 'Program F'],
        title: { text: 'L&D Programme Name' },
      },
      yAxis: {
        title: { text: 'L&D Programme Score' },
        allowDecimals: false,
      },
      legend: {
        align: 'right', // Align legend to top right
        verticalAlign: 'top',
        layout: 'vertical',
      },
      plotOptions: {
        column: {
          grouping: true,
          shadow: false,
          borderWidth: 0,
        },
      },
      series: [
        { name: 'Employee Score', data: [3, 3, 3, 3, 3, 3], color: 'orange' },
        { name: 'Manager Score', data: [2, 2, 2, 2, 2, 2], color: 'blue' },
      ],
    };
  
    // Highcharts.chart('LndPerformanceGraph', this.chartOptions);
  }
  
    
}
function exportChart(exportingOptions: any, ExportingOptions: any, chartOptions: any, Options: any) {
  throw new Error('Function not implemented.');
}

